// extracted by mini-css-extract-plugin
export default {"content":"LS-z","lookName":"MS-z","shopTheLookContainer":"NS-z","productContainer":"OS-z","imageContainer":"PS-z","mainImage":"QS-z"};